import React, { useState, useEffect } from "react";
import classes from "./SavingAccountModal.module.css";
import api, { withCompanyId } from "../../../Components/API/Api";
import { useNavigate } from "react-router-dom";
import { Spinner } from "react-bootstrap";
import Swal from "sweetalert2";
import crop from "../../../Assets/repoort.png";
import verified from "../../../Assets/verified.svg";
import Select from "react-select";

function MonthlyDeductionModal({ isOpen, onClose, onSuccess }) {
  const [rows, setRows] = useState([
    { accountId: "", accountDisplay: "", accountCode: "", amount: "", showDropdown: false },
  ]);

  const [reference, setReference] = useState("");
  const [supplierSearch, setSupplierSearch] = useState("");
  const [showSupplierDropdown, setShowSupplierDropdown] = useState(false);
  const navigate = useNavigate();
  const [debitSearch, setDebitSearch] = useState("");
  const [showDebitDropdown, setShowDebitDropdown] = useState(false);
  const [transactionDate, setTransactionDate] = useState("");
  const [accounts, setAccounts] = useState([]);
  const [accountsLoading, setAccountsLoading] = useState(false);
  const [isSaving, setIsSaving] = useState(false);
  const [description, setDescription] = useState("");
  const [debitAccount, setDebitAccount] = useState("");
  const [outstandingAmount, setOutstandingAmount] = useState("");
  const [selectedLoanAccount, setSelectedLoanAccount] = useState("");
  const [customerOptions, setCustomerOptions] = useState([]);
  const [customerLoading, setCustomerLoading] = useState(false);
  const [loanOptions, setLoanOptions] = useState([]);
  const [employeeOptions, setEmployeeOptions] = useState([]);
  const [supplierOptions, setSupplierOptions] = useState([]);
  const [paymentTypes, setPaymentTypes] = useState([]);
  const [paymentTypesLoading, setPaymentTypesLoading] = useState(false);
  const [selectedPaymentType, setSelectedPaymentType] = useState("");
  const [supplierLoading, setSupplierLoading] = useState(false);
  const [paymentToLoading, setPaymentToLoading] = useState(false);
  const paymentTypeLower = (selectedPaymentType || "").toLowerCase();
  const [creditAccounts, setCreditAccounts] = useState([]);
  const [savingsType, setSavingsType] = useState([]);
  const [savingsLoading, setSavingsLoading] = useState(false);
  const [loadingDropdowns, setLoadingDropdowns] = useState(false);
    const [companyId, setCompanyId] = useState(null);


  const [totalAmount, setTotalAmount] = useState(""); 
  const [receiptTypes, setReceiptTypes] = useState([]);
  const [receiptTypesLoading, setReceiptTypesLoading] = useState(false);
  const [paymentSearch, setPaymentSearch] = useState("");
  const [showPaymentDropdown, setShowPaymentDropdown] = useState(false);
  const [expenseOptions, setExpenseOptions] = useState([]);
  const [currencyOptions, setCurrencyOptions] = useState([]);
  const [paymentModes, setPaymentModes] = useState([]);
  const [receiptType, setReceiptType] = useState("");
  const [selectedCurrency, setSelectedCurrency] = useState("");
  const [selectedPaymentMode, setSelectedPaymentMode] = useState("");
  const [debitAccountsLoading, setDebitAccountsLoading] = useState(false);
  const [supportingDocument, setSupportingDocument] = useState(null);
  const [supportingError, setSupportingError] = useState("");
  const [payableAccounts, setPayableAccounts] = useState([]);
  const [payableAccountsLoading, setPayableAccountsLoading] = useState(false);
  const [pendingInvoicesMap, setPendingInvoicesMap] = useState({});

  const [selectedCompanyId, setSelectedCompanyId] = useState("");
const [selectedProductCode, setSelectedProductCode] = useState("");
const [selectedProductName, setSelectedProductName] = useState("");
const [selectedProducts, setSelectedProducts] = useState([]);
const [selectedProductId, setSelectedProductId] = useState("");
// const [selectedCompanyId, setSelectedCompanyId] = useState("");
const [chequeNo, setChequeNo] = useState("");
const [savingsId, setSavingsId] = useState("");
const [member, setMember] = useState("");

  const handleFileChange = (e) => {
    const file = e.target.files?.[0];
    if (!file) { setSupportingDocument(null); setSupportingError(""); return; }
    if (file.type !== 'application/pdf') { setSupportingError('Only PDF files are allowed.'); setSupportingDocument(null); return; }
    const max = 2 * 1024 * 1024;
    if (file.size > max) { setSupportingError('File must be 2MB or smaller.'); setSupportingDocument(null); return; }
    setSupportingError(""); setSupportingDocument(file);
  };

  // === Reset all form fields to initial state ===
  const resetFormFields = () => {
    setRows([
      { accountId: "", accountDisplay: "", accountCode: "", amount: "", showDropdown: false },
    ]);
    setReference("");
    setSupplierSearch("");
    setShowSupplierDropdown(false);
    setDebitSearch("");
    setShowDebitDropdown(false);
    setTransactionDate("");
    setDescription("");
    setDebitAccount("");
    setOutstandingAmount("");
    setSelectedLoanAccount("");
    setSelectedPaymentType("");
    setPaymentSearch("");
    setShowPaymentDropdown(false);
    setTotalAmount("");
    setSelectedCurrency("");
    setSelectedPaymentMode("");
    setSupportingDocument(null);
    setSupportingError("");

    // Set NGN as default currency if available
    const ngnCurrency = currencyOptions.find(c => c.code === "NGN");
    if (ngnCurrency) setSelectedCurrency(ngnCurrency.id);
  };

  // keep handlePrinter as-is
  const handlePrinter = () => {
    const receiptData = {
      reference,
      transactionDate,
      description,
      selectedCurrency,
      selectedPaymentMode,
      debitAccount,
      totalAmount,
      rows,
    };

    navigate("/preview", {
      state: { invoice: receiptData },
    });
  };

    useEffect(() => {
    const compInfo = localStorage.getItem('companyInfo');
    if (compInfo) {
      try {
        const parsedInfo = JSON.parse(compInfo);
        setCompanyId(parsedInfo.id);
      } catch (e) {
        console.error("Error parsing company info", e);
      }
    }
  }, []);

  // --- Update outstandingAmount when reference (customer selection) changes ---
  useEffect(() => {
    if (!receiptType?.toLowerCase()?.includes("credit customer")) {
      setOutstandingAmount("");
      return;
    }

    if (!reference) {
      setOutstandingAmount("");
      return;
    }

    const customerObj = customerOptions.find(c => String(c.id) === String(reference));
    const balance = customerObj?.balance ?? 0;
    setOutstandingAmount(String(Number(balance) || 0));
  }, [reference, customerOptions, receiptType]);

  // --- Auto-fill totalAmount when supplier is selected for "payment from payables" ---
  useEffect(() => {
    const type = (selectedPaymentType || "").toLowerCase().trim();
    
    if (!type.includes("payment from payables")) {
      return;
    }

    if (!reference) {
      setTotalAmount("");
      setRows((prev) => {
        if (!prev.length) return prev;
        const newRows = [...prev];
        newRows[0] = {
          ...newRows[0],
          amount: "",
        };
        return newRows;
      });
      return;
    }

    const invoiceData = pendingInvoicesMap[reference];
    if (invoiceData) {
      const balance = String(invoiceData.balance || 0);
      setTotalAmount(balance);
      setRows((prev) => {
        if (!prev.length) {
          return [{ accountId: "", accountDisplay: "", accountCode: "", amount: balance, showDropdown: false }];
        }
        const newRows = [...prev];
        newRows[0] = {
          ...newRows[0],
          amount: balance,
        };
        return newRows;
      });
    } else {
      setTotalAmount("");
      setRows((prev) => {
        if (!prev.length) return prev;
        const newRows = [...prev];
        newRows[0] = {
          ...newRows[0],
          amount: "",
        };
        return newRows;
      });
    }
  }, [reference, pendingInvoicesMap, selectedPaymentType]);

  // --- Auto-fill Account Name and Account Code when invoice is selected for "payment from payables" ---
  useEffect(() => {
    const type = (selectedPaymentType || "").toLowerCase().trim();
    
    if (!type.includes("payment from payables")) {
      return;
    }

    if (!reference) {
      // Reset first row when no reference is selected
      setRows((prev) => {
        const newRows = [...prev];
        if (newRows[0]) {
          newRows[0] = {
            ...newRows[0],
            accountId: "",
            accountDisplay: "",
            accountCode: "",
          };
        }
        return newRows;
      });
      return;
    }

    const invoiceData = pendingInvoicesMap[reference];
    if (invoiceData && invoiceData.fullInvoice) {
      const invoice = invoiceData.fullInvoice;
      
      // Get items from invoice (try multiple field names)
      let items = invoice.items || invoice.line_items || invoice.purchase_order_items || invoice.invoice_items || [];
      
      if (Array.isArray(items) && items.length > 0) {
        const firstItem = items[0];
        
        // Get account information from the first item
        let account = null;
        
        // Try to get account from different possible locations
        if (firstItem.account && typeof firstItem.account === 'object') {
          account = firstItem.account;
        } else if (firstItem.debit_gl && typeof firstItem.debit_gl === 'object') {
          account = firstItem.debit_gl;
        }
        
        if (account) {
          const gl_name = account.gl_name || account.name || account.account_name || "";
          const gl_code = account.gl_code || account.code || "";
          const accountId = account.id || "";
          
          // Update the first row with auto-filled account information
          setRows((prev) => {
            const newRows = [...prev];
            if (newRows[0]) {
              newRows[0] = {
                ...newRows[0],
                accountId: accountId,
                accountDisplay: gl_name,
                accountCode: gl_code,
              };
            }
            return newRows;
          });
          
          console.log("✅ Auto-filled account from invoice item:", {
            gl_name,
            gl_code,
            accountId,
          });
        }
      }
    }
  }, [reference, pendingInvoicesMap, selectedPaymentType]);

  // --- Fetch customers (only when receiptType includes credit customer) ---
  useEffect(() => {
    const fetchCustomers = async () => {
      if (!receiptType?.toLowerCase()?.includes("credit customer")) return;

      try {
        setCustomerLoading(true);
        const token = localStorage.getItem("authToken");
        const res = await api.get('/v1/customer/get');

        if (res.data && Array.isArray(res.data.data)) {
          setCustomerOptions(res.data.data);
        } else {
          setCustomerOptions([]);
        }
      } catch (err) {
        console.error("Error fetching customers:", err);
        setCustomerOptions([]);
      } finally {
        setCustomerLoading(false);
      }
    };

    fetchCustomers();
  }, [receiptType]);

  // --- Fetch loans (when receiptType includes loan repayment) ---
  useEffect(() => {
    const fetchLoanOptions = async () => {
      if (!receiptType?.toLowerCase()?.includes("loan repayment")) return;

      try {
        setPaymentToLoading(true);
        const token = localStorage.getItem("authToken");
        const res = await api.get('/v1/loans');

        if (res.data && Array.isArray(res.data.data)) {
          setLoanOptions(res.data.data);
        } else {
          setLoanOptions([]);
        }
      } catch (err) {
        console.error("Error fetching loans:", err);
        setLoanOptions([]);
      } finally {
        setPaymentToLoading(false);
      }
    };

    fetchLoanOptions();
  }, [receiptType]);

  // --- Fetch employees (when receiptType includes employee payment) ---
  useEffect(() => {
    const fetchEmployeeOptions = async () => {
      if (!receiptType?.toLowerCase()?.includes("employee payment")) return;

      try {
        setPaymentToLoading(true);
        const token = localStorage.getItem("authToken");
        const res = await api.get('/v1/employee/paginated');

        // Handle paginated response: { status, message, data: { current_page, data: [...], ... } }
        if (res.data && res.data.data?.data && Array.isArray(res.data.data.data)) {
          setEmployeeOptions(res.data.data.data);
        } else {
          setEmployeeOptions([]);
        }
      } catch (err) {
        console.error("Error fetching employees:", err);
        setEmployeeOptions([]);
      } finally {
        setPaymentToLoading(false);
      }
    };

    fetchEmployeeOptions();
  }, [receiptType]);

  // --- Fetch payment types ---
  useEffect(() => {
    const fetchPaymentTypes = async () => {
      setLoadingDropdowns(true);
      try {
        const token = localStorage.getItem("authToken");
        const res = await api.get('/v1/get-monthly-deduction-months', { params: { name: 'payment' } });
        if (res.data && Array.isArray(res.data.data.months)) {
          setPaymentTypes(res.data.data.months);
        } else {
          setPaymentTypes([]);
        }
      } catch (err) {
        setPaymentTypes([]);
      } finally {
        setLoadingDropdowns(false);
      }
    };
    fetchPaymentTypes();
  }, []);

  // fetch saving types
  useEffect(() => {
    const fetchSavingsTypes = async () => {
      setSavingsLoading(true);
      try {
        const token = localStorage.getItem("authToken");
        const res = await api.get('/v1/savings_product', 
          { 
            // params: { name: 'payment' } 
        }
      );
        if (res.data && Array.isArray(res.data.data)) {
          setSavingsType(res.data.data);
        } else {
          setSavingsType([]);
        }
      } catch (err) {
        setSavingsType([]);
      } finally {
        setSavingsLoading(false);
      }
    };
    fetchSavingsTypes();
  }, []);

  // --- Fetch suppliers when selectedPaymentType includes supplier or payable ---
  useEffect(() => {
    const fetchSuppliers = async () => {
      const type = (selectedPaymentType || "").toLowerCase().trim();

      // Handle "payment from payables" - fetch from pending purchase invoices endpoint
      if (type.includes("payment from payables")) {
        setSupplierLoading(true);
        try {
          const token = localStorage.getItem("authToken");
          const res = await api.get('/v1/retrieve-pending-purchase-invoices');

          const invoices = res?.data?.data;
          if (Array.isArray(invoices)) {
            const invoiceMap = {};
            const options = [];
            const processedSuppliers = new Map();

            // Process invoices to group by supplier and create display options
            invoices.forEach((invoice) => {
              const invoiceId = String(invoice.id);
              const supplierName = invoice.supplier?.name || `Supplier ${invoice.supplier_id}`;
              const invoiceNumber = invoice.invoice_number;
              const balance = invoice.balance;
              
              // Store invoice data by its ID
              invoiceMap[invoiceId] = {
                id: invoiceId,
                invoiceId,
                supplierName,
                invoiceNumber,
                balance,
                fullInvoice: invoice,
              };

              // Create display option: "Supplier Name (Invoice Number)"
              const displayLabel = `${supplierName} (${invoiceNumber})`;
              options.push({
                id: invoiceId,
                name: displayLabel,
                balance,
              });
            });

            // Log invoice structure for debugging item extraction
            console.log("📦 Pending invoices API response structure:", {
              firstInvoice: invoices[0],
              allInvoices: invoices
            });

            setPendingInvoicesMap(invoiceMap);
            setSupplierOptions(options);
          } else {
            setPendingInvoicesMap({});
            setSupplierOptions([]);
          }
        } catch (err) {
          console.error("Error fetching pending purchase invoices:", err);
          setPendingInvoicesMap({});
          setSupplierOptions([]);
        } finally {
          setSupplierLoading(false);
        }
        return;
      }

      // Original logic for regular supplier selection
      if (!type.includes("supplier") && !type.includes("payable")) {
        setSupplierOptions([]);
        setPendingInvoicesMap({});
        return;
      }

      setSupplierLoading(true);
      try {
        const token = localStorage.getItem("authToken");
        const res = await api.get('/v1/beneficiary');

        const suppliers = res?.data?.data;
        if (Array.isArray(suppliers)) {
          const options = suppliers.map((s) => ({
            id: s.id,
            name: s.supplier_name || s.name || `Supplier ${s.id}`,
          }));
          setSupplierOptions(options);
          setPendingInvoicesMap({});
        } else {
          setSupplierOptions([]);
          setPendingInvoicesMap({});
        }
      } catch (err) {
        console.error("Error fetching suppliers:", err);
        setSupplierOptions([]);
        setPendingInvoicesMap({});
      } finally {
        setSupplierLoading(false);
      }
    };

    fetchSuppliers();
  }, [selectedPaymentType]);

  // --- Fetch Account Names and Codes ---
  useEffect(() => {
    const fetchAccounts = async () => {
      try {
        const token = localStorage.getItem("authToken");
        const res = await api.get('/v1/get-expense-accounts');
        if (res.data && res.data.status && Array.isArray(res.data.data)) {
          setAccounts(res.data.data);
        }
      } catch (err) {
        console.error("Failed to fetch expense accounts", err);
      }
    };
    fetchAccounts();
  }, []);

  // --- Fetch Payable Accounts when payment type includes "payable" ---
  useEffect(() => {
    const fetchPayableAccounts = async () => {
      const type = (selectedPaymentType || "").toLowerCase().trim();

      if (!type.includes("payable")) {
        setPayableAccounts([]);
        return;
      }

      setPayableAccountsLoading(true);
      try {
        const token = localStorage.getItem("authToken");
        const res = await api.get('/v1/get-payable-accounts');

        if (res.data && Array.isArray(res.data.data)) {
          setPayableAccounts(res.data.data);
        } else {
          setPayableAccounts([]);
        }
      } catch (err) {
        console.error("Error fetching payable accounts:", err);
        setPayableAccounts([]);
      } finally {
        setPayableAccountsLoading(false);
      }
    };

    fetchPayableAccounts();
  }, [selectedPaymentType]);

  // --- Fetch Payment Methods ---
  useEffect(() => {
    const fetchPaymentModes = async () => {
      try {
        const token = localStorage.getItem("authToken");
        const res = await api.get('/v1/income/get-payment-method');

        if (res.data && Array.isArray(res.data.data)) {
          setPaymentModes(res.data.data);
        } else {
          setPaymentModes([]);
        }
      } catch (err) {
        console.error("Error fetching payment methods:", err);
        setPaymentModes([]);
      }
    };
    fetchPaymentModes();
  }, []);

  // --- Fetch Currencies ---
  useEffect(() => {
    const fetchCurrencies = async () => {
      try {
        const token = localStorage.getItem("authToken");
        const res = await api.get('/v1/fetch-all-currencies');

        if (res.data && Array.isArray(res.data.data)) {
          setCurrencyOptions(res.data.data);

          // ✅ Set NGN as default
          const ngnCurrency = res.data.data.find(c => c.code === "NGN");
          if (ngnCurrency) setSelectedCurrency(ngnCurrency.id);
        }
      } catch (err) {
        console.error("Error fetching currencies:", err);
      }
    };
    fetchCurrencies();
  }, []);

  const [savingsNo, setSavingsNo] = useState('');

useEffect(() => {
  const fetchSavingsNo = async () => {
    try {
      const token = localStorage.getItem("authToken");
      const res = await api.get(`/v1/account/generate-saving-code?savings_type=${selectedProductId}`);

     
        setSavingsNo(res.data.data);
 
    } catch (err) {
      console.error("Error fetching savings code:", err);
    }
  };

  // Only execute the function if selectedPaymentType is truthy
  if (selectedProductId) {
    fetchSavingsNo();
  }
}, [selectedProductId]);

  useEffect(() => {
    const fetchCreditAccounts = async () => {
      setDebitAccountsLoading(true);
      try {
        const token = localStorage.getItem("authToken");
        const res = await api.get('/v1/bank-accounts');

        if (res.data && Array.isArray(res.data.data)) {
          const creditAccounts = res.data.data.map((acc) => ({
            value: acc.id,
            label: acc.gl_name || acc.name || acc.account_name,
            gl_code: acc.gl_code || acc.code,
            fullAccount: acc,
          }));
          setCreditAccounts(creditAccounts);
        } else {
          setCreditAccounts([]);
        }
      } catch (error) {
        console.error("Error fetching credit accounts:", error);
        setCreditAccounts([]);
      } finally {
        setDebitAccountsLoading(false);
      }
    };

    if (isOpen) fetchCreditAccounts();
  }, [isOpen]);

  if (!isOpen) return null;

  // === TABLE HANDLERS ===
  const addLine = () => {
    setRows((prev) => [
      ...prev,
      { accountId: "", accountDisplay: "", amount: "", showDropdown: false },
    ]);
  };

  const duplicateRow = (index) => {
    setRows((prev) => {
      const newRows = [...prev];
      const emptyRow = {
        accountId: "",
        accountDisplay: "",
        amount: "",
        showDropdown: false,
      };
      newRows.splice(index + 1, 0, emptyRow);
      return newRows;
    });
  };

  const removeRow = (index) => {
    setRows((prev) => {
      if (prev.length === 1) return prev;
      return prev.filter((_, i) => i !== index);
    });
  };

  // const handleChange = (index, field, value) => {
  //   setRows((prev) => {
  //     const newRows = [...prev];
  //     const row = { ...newRows[index] };

  //     if (field === "showDropdown") {
  //       row.showDropdown = value;
  //     } else if (field === "account") {
  //       row.accountId = value?.id ?? "";
  //       row.accountDisplay = `${value?.gl_name ?? value?.name ?? ""}`;
  //       row.accountCode = value?.gl_code ?? value?.code ?? "";
  //       row.showDropdown = false;
  //     } else if (field === "accountDisplay") {
  //       row.accountDisplay = value;
  //       row.accountId = "";
  //       row.accountCode = "";
  //       row.showDropdown = true;
  //     } else if (field === "amount") {
  //       row.amount = value;
  //     }

  //     newRows[index] = row;
  //     return newRows;
  //   });
  // };

  const totalDebit = parseFloat(totalAmount || 0);
  const totalCredit = rows.reduce(
    (sum, r) => sum + (parseFloat(r.amount) || 0),
    0
  );
  const isBalanced = totalDebit === totalCredit;

  // === handleSubmit ===
const handleSubmit = async (e) => {
  e.preventDefault();

  const errors = [];

 

 

  // if (!savingsNo)
  //   errors.push("Savings Account Number is required");

  // if (!selectedProductId)
  //   errors.push("Savings type is required");

  // if (!selectedCurrency)
  //   errors.push("Currency is required");

 

  if (errors.length > 0) {
    Swal.fire({
      icon: "error",
      title: "Missing Required Fields",
      html: errors.map(err => `<p>${err}</p>`).join(""),
      customClass: { popup: "swal-highest-zindex" },
      didOpen: () => {
        const swalPopup = document.querySelector(".swal2-container");
        if (swalPopup) swalPopup.style.zIndex = "99999";
      },
    });

    return;
  }

  setIsSaving(true);

  try {
   

    const payload = {
      date: member,
      company_id: companyId,
      // amount: Number(totalAmount),
      // transaction_date: transactionDate,
      // savings_type: savingsId,
      
      // currency: selectedCurrency,
   
    };

    console.log("Submitting Payload:", payload);

    let response;

    if (supportingDocument) {
      const fd = new FormData();

      // fd.append("member_id", payload.member_id);
      fd.append("date", payload.date);
      fd.append("company_id", payload.company_id);
      // fd.append("amount", payload.amount);
      // fd.append("transaction_date", payload.transaction_date);
      // fd.append("savings_type", payload.savings_type);
      
      
      
      // fd.append("currency", payload.currency);
     

      

      console.log(
        "Submitting FormData:",
        Object.fromEntries(fd.entries())
      );

      response = await api.post(
        "/v1/save-monthly-deduction",
        fd,
        {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        }
      );
    } else {
      response = await api.post(
        "/v1/save-monthly-deduction",
        payload
      );
    }

    Swal.fire({
      icon: "success",
      title: "Success",
      text:
        response?.data?.message ||
        "Member savings created successfully",
      customClass: { popup: "swal-highest-zindex" },
      didOpen: () => {
        const swalPopup = document.querySelector(".swal2-container");
        if (swalPopup) swalPopup.style.zIndex = "99999";
      },
    });
        // reset form
   resetFormFields();

// Refresh the parent list
if (onSuccess) {
    await onSuccess();
}

// Close the modal
onClose();

    // notify parent if needed
    // onSuccess?.(response.data);

    // close modal
    onClose();
    console.log("Success:", response.data);

  } catch (error) {
    console.error("API Error:", error);

    const apiErrors =
      error?.response?.data?.errors;

    let errorHtml = "";

    if (apiErrors) {
      errorHtml = Object.entries(apiErrors)
        .map(([field, messages]) => {
          return `
            <p>
              <strong>${field}</strong>: 
              ${messages.join(", ")}
            </p>
          `;
        })
        .join("");
    }

    Swal.fire({
      icon: "error",
      title: "Save Failed",
      html:
        errorHtml ||
        error?.response?.data?.message ||
        "Failed to save member savings",
      confirmButtonColor: "#000000ff",
      customClass: { popup: "swal-highest-zindex" },
      didOpen: () => {
        const swalContainer =
          document.querySelector(".swal2-container");

        if (swalContainer)
          swalContainer.style.zIndex = "99999";
      },
    });
  } finally {
    setIsSaving(false);
  }
};

const memberOptions = paymentTypes.map((month) => ({
  value: month,
  label: month,
}));

  return (
    <div className={classes.modalOverlay}>
      <div className={classes.modalContent}>
        <h3 className={classes.title}>Create New Monthly Deductions</h3>
       
          <div className={classes.Group3} style={{marginTop: '1rem',paddingBottom: 20, borderBottom: '1px solid #b7b7b7'}}>
            <label>Month</label>
          <Select
            options={memberOptions}
            value={memberOptions.find(option => option.value === member) || null}
            onChange={(selected) => setMember(selected?.value || "")}
            placeholder="Select Month..."
            isLoading={loadingDropdowns}
            isSearchable
              styles={{
              control: (provided) => ({

                ...provided,

                minHeight: "35px",

                height: "35px",

                borderRadius: "6px",

                borderColor: "#d1d5db",

                fontSize: 13,

                zIndex: 99999,

                boxShadow: "none",

                "&:hover": {

                  borderColor: "#6b7280",

                },

              }),

              valueContainer: (provided) => ({

                ...provided,

                height: "35px",

                padding: "0 8px",

              }),

              input: (provided) => ({

                ...provided,

                margin: 0,

                padding: 0,

                fontSize: 13

              }),

              indicatorsContainer: (provided) => ({

                ...provided,

                height: "35px",

              }),

              clearIndicator: (provided) => ({

                ...provided,

                padding: "4px",

              }),

              dropdownIndicator: (provided) => ({

                ...provided,

                padding: "4px",

              }),

              menu: (provided) => ({

                ...provided,

                zIndex: 99999,

                fontSize: 13

              }),

            }}

          />
          </div>

          

          {/* <div className={classes.Group3} style={{marginTop: '1rem', }}>
            <label>Savings Product</label>
              <div className={classes.searchableDropdown} >
                <select
                  value={selectedProductId}
                  onChange={(e) => {
                    const productId = Number(e.target.value);

                    const selectedItem = savingsType.find(
                      (item) => item.id === productId
                    );

                    if (!selectedItem) return;

                    setSelectedProductId(productId);
                    setSelectedCompanyId(selectedItem.company_id);
                    setSavingsId(selectedItem.id);

                    setSelectedProducts((prev) => {
                      const exists = prev.some(
                        (product) => product.id === selectedItem.id
                      );

                      if (exists) return prev;

                      return [...prev, selectedItem];
                    });
                  }}
                >
                  <option value="">Select Savings Product</option>

                  {savingsLoading ? (
                    <option disabled>Loading savings products...</option>
                  ) : (
                    savingsType.map((product) => (
                      <option
                        key={product.id}
                        value={product.id}
                      >
                        {product.product_name}
                      </option>
                    ))
                  )}
                </select>
              </div>
          </div> */}
          {/* <div className={classes.Group3 } style={{marginTop: '1rem', }}>
            <label>Transaction Date</label>
            <input
              type="date"
              value={transactionDate}
              onChange={(e) => setTransactionDate(e.target.value)}
              required
            />
          </div> */}
          {/* <div style={{
            display: 'flex',
            flexDirection: 'row',
            justifyContent: 'space-between',
            alignItems: 'center',
            marginTop: '1rem',
          }}>

                    <div className={classes.Group2} >
                      <label>Savings Account Number</label>
                      <input
                        type="text"
                        placeholder="Savings Account Number"
                        value={savingsNo}
                        disabled
                        // onChange={(e) => setDescription(e.target.value)}
                      />
                    </div>

                    <div className={classes.Group2}>
                      <label>Currency</label>
                      <select
                        value={selectedCurrency}
                        onChange={(e) => setSelectedCurrency(e.target.value)}
                      >
                        <option value="">Select Currency</option>
                        {currencyOptions.map((c) => (
                          <option key={c.id} value={c.id}>
                            {c.code || c.name}
                          </option>
                        ))}
                      </select>
                    </div>
          </div> */}
          {/* <div className={classes.Group3 } style={{marginTop: '1rem', }}>
                      <label>Opening Deposit</label>
                      <input
                        type="number"
                        placeholder="Enter Opening Deposit"
                        style={{ textAlign: "right" }}
                        value={totalAmount}
                        onChange={(e) => setTotalAmount(e.target.value)}
                      />
          </div> */}
        <form 
        // onSubmit={handleSubmit}
        >
          <div className={classes.footerButtons}>
            <button
              type="button"
              className={classes.resetBtn}
              onClick={resetFormFields}
            >
              Reset
            </button>


            <button
              type="submit"
              onClick={handleSubmit}
              className={classes.submitBtn}
              // disabled={isSaving || !isBalanced || !selectedPaymentType || !reference || !transactionDate || !selectedPaymentMode || !debitAccount}
            >
              {isSaving ? (
                <span style={{ display: "inline-flex", alignItems: "center", gap: 8 }}>
                  <Spinner animation="border" size="sm" /> Processing...
                </span>
              ) : (
                "Process Deduction"
              )}
            </button>
          </div>
        </form>

        <button className={classes.closeBtn} onClick={onClose}>
          ×
        </button>
      </div>
    </div>
  );
}

export default MonthlyDeductionModal;